let count = 0;
let setLoading: (state: boolean) => void = () => {};

export function setLoaderSetter(setter: (state: boolean) => void) {
  setLoading = setter;
}

export function showLoader() {
  count++;
  if (count === 1) {
    setLoading(true);
  }
}

export function hideLoader() {
  count = Math.max(count - 1, 0); // защита от ухода в минус
  if (count === 0) {
    setLoading(false);
  }
}
